import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ExtranetHotelRoom } from 'app/typings/core/extranet/hotel/rooms';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useHotelRooms(
  hotelId?: number,
  options?: Omit<
    UseQueryOptions<
      ExtranetHotelRoom[] | null,
      Error,
      ExtranetHotelRoom[] | null,
      QueryKey
    >,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery<ExtranetHotelRoom[] | null>({
    queryKey: [CORE_QUERY_KEYS.hotelRooms, { id: hotelId }],
    queryFn: () =>
      hotelId
        ? (apiRequest({
            path: ENDPOINTS.getHotelRooms,
            params: { id: hotelId.toString() },
          }) as Promise<ExtranetHotelRoom[]>)
        : Promise.resolve(null),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId,
    ...options,
  });
}
